import { GenericComponent } from "../../components/GenericComponent";
import { Matriz } from "../../models/riesgo/Matriz";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { Generico } from "../../components/Generico";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { useToken } from "../../components/useToken";
import { Button } from "primereact/button";
import { Actividades } from "./Actividades";
import { Checkbox } from "primereact/checkbox";

export const Riesgos = () => {
    const generic = new GenericComponent();
    const omodel = new Matriz();
    const { getRol } = useToken();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const [registros, setRegistros] = useState(null);
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const [riesgo, setRiesgo] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [catalogoFiltros, setCatalogoFiltros] = useState(null);
    const toast = useRef(null);
    const [dialogMatriz, setDialogMatriz] = useState(false);
    const [dialogDetalle, setDialogDetalle] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inDrop, inNumber } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });
    const [editarApetitos, setEditarApetitos] = useState(false);
    const [funcionalidades, setFuncionalidades] = useState([]);

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.rol = getRol();
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        matrizSrv.listado('matriz-riesgo/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setCatalogos(res.data.catalogos);
                const filtros = {
                    areas: res.data.catalogos.areas?.map(item => ({ label: item.nombre, value: item.cat_id }))
                };
                setCatalogoFiltros(filtros);
                setFuncionalidades(res.data.funcionalidades);
            }
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogMatriz(true);
    }

    const onSubmit = (data) => {
        if (editarApetitos) {
            let hayError = false;
            ['apetito_inherente', 'tolerancia_inherente', 'apetito_residual', 'tolerancia_residual'].forEach(field => {
                if (data[field] > 5) { setError(field, { type: 'manual', message: 'El valor máximo permitido es 5' }); hayError = true; }
            });
            // Alerta Apetito > Tolerancia
            if (data.apetito_inherente > data.tolerancia_inherente) {
                setError('apetito_inherente', { type: 'manual', message: 'El apetito debe ser menor o igual a la tolerancia' }); hayError = true;
            }
            if (data.apetito_residual > data.tolerancia_residual) {
                setError('apetito_residual', { type: 'manual', message: 'El apetito debe ser menor o igual la tolerancia' }); hayError = true;
            }
            if (hayError) return;
        } else { delete data.apetito_inherente; delete data.tolerancia_inherente; delete data.apetito_residual; delete data.tolerancia_residual; }
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogMatriz(false);
                loadLazyData();
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            });
        }
        else {
            matrizSrv.editar(data, 'matriz-riesgo/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogMatriz(false);
                loadLazyData();
            }).catch(error => {
                generic.funcErrorHibrida(error, toast, setError);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(riesgo?.id, 'matriz-riesgo/consulta').then(res => {
            const _riesgo = res.data;
            const tipoNegocio = catalogos.areas.find(a => a.cat_id === _riesgo.tipo_negocio);
            _riesgo.tipo_negocio = tipoNegocio || null;
            reset(generic.renewValues(_riesgo, omodel.model));
            setDialogMatriz(true);
        });
    }

    const confirm = (_delete) => {
        let message = '¿Está seguro de realizar esta acción?';

        if (_delete) {
            message = '¿Está seguro de eliminar la información?';
        } else {
            switch (riesgo?.nemonico) {
                case 'BORRADOR':
                    message = '¿Está seguro de enviar la matriz?';
                    break;
                case 'ENVIADO':
                    message = '¿Está seguro de finalizar la matriz?';
                    break;
                default:
                    message = '¿Está seguro de continuar con esta acción?';
            }
        }
        confirmDialog({
            group: 'eliminar-riesgo',
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => _delete ? eliminar() : finalizar()
        });
    }

    const finalizar = () => {
        matrizSrv.editar({ id: riesgo?.id, nemonico: riesgo?.nemonico }, 'matriz-riesgo/aprobar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(riesgo?.id, 'matriz-riesgo/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const detalles = () => {
        setDialogDetalle(true);
    }

    const confirmarVolver = (destino) => {
        let message = '';

        switch (destino) {
            case 'ENVIADO':
                message = '¿Está seguro de volver la actividad a estado enviado?';
                break;
            case 'BORRADOR':
                message = '¿Está seguro de volver la actividad a estado borrador?';
                break;
            default:
                message = '¿Está seguro de continuar con esta acción?';
        }

        confirmDialog({
            group: 'eliminar-riesgo',
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => volverEstado()
        });
    };

    const volverEstado = () => {
        matrizSrv.editar({ id: riesgo?.id, nemonico: riesgo?.nemonico }, 'matriz-riesgo/volver-estado').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
        });
    };

    const itemsMenu = () => {
        const items = [];
        // Estado BORRADOR
        if (riesgo?.nemonico === 'BORRADOR') {
            if (permss?.actualizar)
                items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editar() });
            if (permss?.actualizar)
                items.push({ label: 'Actividades', icon: 'pi pi-equals', command: () => detalles() });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-ENVIAR-MATRIZ'))
                items.push({ label: 'Enviar', icon: 'pi pi-send', command: () => confirm(false) });
            if (permss?.eliminar)
                items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirm(true) });
        }
        // Estado ENVIADO
        if (riesgo?.nemonico === 'ENVIADO') {
            if (permss?.actualizar)
                items.push({ label: 'Actividades', icon: 'pi pi-equals', command: () => detalles() });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-FINALIZAR-MATRIZ'))
                items.push({ label: 'Finalizar', icon: 'pi pi-check', command: () => confirm(false) });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-VOLVER-BORRADOR-MATRIZ'))
                items.push({ label: 'Volver a Borrador', icon: 'pi pi-undo', command: () => { confirmarVolver('BORRADOR'); } });
        }
        // Estado FINALIZADO
        if (riesgo?.nemonico === 'FINALIZADO') {
            if (permss?.consultar)
                items.push({ label: 'Descargar Reporte', icon: 'pi pi-download', command: () => descargar('matriz-riesgo/descarga', `0/${riesgo?.id}`, `${riesgo?.nombre} ${riesgo?.sigla}.pdf`) });
            if (permss?.actualizar)
                items.push({ label: 'Actividades', icon: 'pi pi-equals', command: () => detalles() });
            if (permss?.actualizar && siOpcion('MATRIZ-RIESGOS-VOLVER-ENVIADO-MATRIZ'))
                items.push({ label: 'Volver a Enviado', icon: 'pi pi-undo', command: () => { confirmarVolver('ENVIADO'); } });
        }
        return [{ label: 'Opciones', items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nueva Matriz" : " Editar Matriz"}
                </span>
            </div>
        );
    }

    const leftTool = () => {
        return (
            <>
                <Button icon="pi pi-plus" className="p-button-success mr-2" tooltip="Nueva matriz de riesgos" tooltipOptions={{ position: 'top' }} type="button" onClick={openNew} />
            </>
        );
    }

    const descargar = (url, data, filename) => {
        return matrizSrv.descargar(url, data).then(res => {
            generic.downloadPdf(res, filename);
        }).catch(error => {
            if (error?.response?.data) {
                error.response.data.message = 'No se pudo generar el reporte';
            }
            generic.funcMessageBlobError('Error al descargar', error, toast);
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(strOpcion));
    }

    return (
        <>
            <ConfirmDialog group="eliminar-riesgo" className="dialog-personalizado" />
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {!dialogDetalle && <Toolbar className="mb-4" start={leftTool}></Toolbar>}
                {!dialogDetalle && table({ action01: accionesTbl, reg: setRiesgo, items: itemsMenu(), catalogos: catalogoFiltros })}
                {dialogDetalle && <Actividades riesgo={riesgo} permss={permss} toast={toast} generic={generic} regresar={setDialogDetalle} descargar={descargar} funcionalidades={funcionalidades} />}
            </Card>

            <Dialog visible={dialogMatriz} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogMatriz(false);
            }}
                style={{ maxWidth: '500px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('nombre', { icon: 'pi pi-user', iconPosition: 'left' }, 12)}
                        {inText('sigla', { icon: 'pi pi-book', iconPosition: 'left' }, 12)}
                        {inText('descripcion', { icon: 'pi pi-bars', iconPosition: 'left' }, 12)}
                        {catalogos?.areas?.length > 1 && inDrop('tipo_negocio', catalogos?.areas, { lab: omodel.optionLabel }, 12)}
                    </div>

                    <div className="flex flex-wrap justify-content-center gap-3 mb-3">
                        <div className="flex align-items-center">
                            <Checkbox inputId="editar_apetitos" checked={editarApetitos} onChange={(e) => setEditarApetitos(e.checked)} />
                            <label htmlFor="editar_apetitos" className="ml-2">Modificar Apetitos y Tolerancias</label>
                        </div>
                    </div>

                    {editarApetitos && (
                        <div className="card p-3 mt-3 shadow-2">
                            <h5 className="mb-3">Apetitos y Tolerancias para la Matriz</h5>
                            <div className="formgrid grid">
                                {inNumber('apetito_inherente', 0, false, { icon: 'pi pi-chart-line', tooltip: 'Nivel de apetito inherente permitido', min: 0, }, 6)}
                                {inNumber('tolerancia_inherente', 0, false, { icon: 'pi pi-sliders-h', tooltip: 'Tolerancia inherente máxima', min: 0, }, 6)}
                                {inNumber('apetito_residual', 0, false, { icon: 'pi pi-chart-line', tooltip: 'Nivel de apetito residual esperado', min: 0, }, 6)}
                                {inNumber('tolerancia_residual', 0, false, { icon: 'pi pi-sliders-h', tooltip: 'Tolerancia residual máxima', min: 0, }, 6)}
                            </div>
                        </div>
                    )}
                    {generic.buttonsForms(setDialogMatriz)}
                </form>
            </Dialog>
        </>
    )
}
